<template>
  <el-dialog
    title="提现申请"
    width="504px"
    :show-close="false"
    :close-on-click-modal="false"
    :visible="true"
    class="chartDia"
  >
    <div slot="title" class="slotTit">提现申请</div>
    <el-form
      ref="ruleForm"
      class="ruleForm"
      label-width="120px"
      :rules="rules"
      :model="ruleForm"
    >
      <el-form-item label="提现通道：">
        <el-select
          @change="setPayPassagewayCode"
          v-model="ruleForm.payPassagewayCode"
          disabled
        >
          <el-option
            v-for="item in BANK_MAPPING"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="可提现金额" style="margin-bottom:0"></el-form-item>
      <div style="margin-left:38px;">
        <b style="font-size:20px;">{{ table.balance | money }}</b>
        元
      </div>
      <el-form-item label="公司名称：">
        {{ table.companyName }}
      </el-form-item>
      <el-form-item label="银行账号：">
        {{ table.openBankNumber }}
      </el-form-item>
      <el-form-item label="开户行：">
        {{ table.openBankName }}
      </el-form-item>
      <el-form-item label="提现金额：" style="margin-top:10px" prop="amount">
        <el-input
          v-model="ruleForm.amount"
          :placeholder="`提现金额不低于${outFee_mixin + 1}元`"
        ></el-input>
        &nbsp;元
      </el-form-item>
      <el-form-item label="实际到账金额：" style="margin-top:10px">
        <div>
          <b style="color:#FAB119;font-weight:normal;">
            {{ arrivalMoney }}
          </b>
          元
        </div>
      </el-form-item>
      <el-form-item label="手续费：">
        <div>
          {{ outFee_mixin }}元
          <span style="color:#f10909;font-size:12px;">*</span>
          <span style="color:#c4c4c4;font-size:12px;">
            提现将收取
            <b style="color:#F10909;font-size:12px;font-weight:normal;">
              {{ outFee_mixin }}元/笔
            </b>
            的提现手续费
          </span>
        </div>
      </el-form-item>
      <el-form-item style="margin-top:10px">
        <el-button
          type="primary"
          @click="confirm('ruleForm')"
          style="margin-right:100px;"
        >
          提现
        </el-button>
        <el-button type="primary" @click="cancel" plain>取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { withdrawals } from '@/api/ajax';
import outFeeMixin from '@/Mixin/out-fee-mixin.js';
import { twoDecimal, moneyComplete } from '@/tools/money';

export default {
  name: 'cash',
  mixins: [outFeeMixin],
  props: {
    leftNum: {
      type: String
    },
    cashObj: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    arrivalMoney() {
      const money = twoDecimal(
        moneyComplete(this.ruleForm.amount) - moneyComplete(this.outFee_mixin),
        100
      );
      return Math.max(money, 0);
    },
    BANK_MAPPING() {
      return this.$store.state.bank.banks;
    }
  },
  data() {
    const checkMin = (rule, value, callback) => {
      const minOutFee = this.outFee_mixin + 1;
      if (isNaN(value) || !/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('提现金额非法'));
      } else if (value < minOutFee) {
        callback(new Error(`提现金额不得小于${minOutFee}元`));
      } else if (value > this.table.balance / 100) {
        callback(new Error('提现金额不得大于可提现金额'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        amount: 0,
        payPassagewayCode: this.cashObj.payPassagewayCode // 提现通道
      },
      table: {},
      rules: {
        amount: [
          {
            required: true,
            message: '提现金额不能为空',
            trigger: 'blur'
          },
          {
            validator: checkMin,
            trigger: 'change'
          }
        ]
      }
    };
  },

  methods: {
    confirm(formName) {
      //确认提现
      this.$refs[formName].validate(valid => {
        if (valid) {
          withdrawals
            .firstSubmitWithdrawals({
              ...this.ruleForm,
              amount: moneyComplete(this.ruleForm.amount)
            })
            .then(res => {
              this.$parent.cashObj = Object.assign(
                this.ruleForm,
                res.data.data
              );
              this.$parent.componentName = 'cashConfirm';
            });
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$parent.componentName = '';
    },
    setPayPassagewayCode() {
      withdrawals
        .loadLastWithdrawals({
          payPassagewayCode: this.ruleForm.payPassagewayCode
        })
        .then(res => {
          this.table = res.data.data;
        });
    }
  },
  created() {
    this.setPayPassagewayCode();
  }
};
</script>
